import styled from "styled-components";

export const CMCarouselContainer = styled.div((props) => ({
  width: "23%",
}));

export const CMAuctionDescription = styled.div((props) => ({
  width: "41%",
  margin: "0 4.5%",
  maxWidth: "458px",

  [`@media (min-width: 2000px)`]: {
    maxWidth:"100%"
  },

  '@media (max-width: 1023px)': {
    display: 'flex',
    flexDirection: 'column'
  },

  "& > div": {
    display: "flex",
    width: "235px",
    marginBottom: props.theme.spacers["3"],
    justifyContent: "space-between",
    '@media (max-width: 1023px)': {
      order: '2',
    },
  },

  "& h4,span,p": {
    margin: 0,
  },

  "& h4": {
    letterSpacing: "-0.3px",
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.workSans,
    [`@media (min-width: 2000px)`]: {
      fontSize:"3vh"
     },
    '@media (max-width: 1023px)': {
      order: '3',
      fontSize: '16px',
    },
  },

  "& p": {
    [`@media (min-width: 2000px)`]: {
      fontSize: '2.5vh',
     },
    '@media (max-width: 1023px)': {
        order: '5',
        fontSize: '15px',
    },
  },

  "& span": {
    display: "block",
    margin: `${props.theme.spacers["3"]} 0`,
    color: props.theme.palette.gray["900"],
    fontSize: '15px',
    [`@media (min-width: 2000px)`]: {
      fontSize: '2.5vh',
     },
    '@media (max-width: 1023px)': {
      order: '4',
    },
  },

  [`@media${props.theme.breakpoints.lg}`]: {
    maxWidth: "unset",
    marginLeft: 0,
    marginRight: 0,
  },
}));

export const CMAuctionCard = styled.div((props) => ({
  width: "32%",
  maxWidth: "348px",

  [`@media (min-width: 2000px)`]: {
    maxWidth: "100%",
  },

  [`@media${props.theme.breakpoints.lg}`]: {
    maxWidth: "unset",
    marginLeft: 0,
    marginRight: 0,
    "& .MetricsResponsiveHide": {
      display: "none",
    },
  },
}));

export const CMVideoCarousel = styled.div((props) => ({
  flexDirection: "column",
}));

export const CMDivider = styled.div((props) => ({
  width: "1528px",
  position: "absolute",
  top: 0,
  left: "-140px",
  border: "none",
  height: "1.25px",
}));

export const CMAuctionItem = styled.div((props) => ({
  padding: "40px 0 0 0",
  position: "relative",

  "& > div": {
    display: "flex",
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    "&.scheduled-item": {
      [`${CMCarouselContainer}`]: {
        "& div.swiper": {
          width: "190px",
        },
      },
    },
    [`${CMCarouselContainer}`]: {
      "& div.swiper": {
        width: "190px",
      },
    },

    "& > div": {
      flexDirection: "column",

      "& > div": {
        width: "100%",
        padding: 0,
      },
    },
  },

  [`${CMCarouselContainer}`]: {
    marginTop: "-8px",
  },

  [`${CMAuctionCard}`]: {
    marginTop: "40px",
  },

  "&.scheduled-item:not(.mobile)": {
    [`${CMAuctionDescription}`]: {
      maxWidth: "502px",
      margin: "0 4%",
    },

    [`${CMAuctionCard}`]: {
      maxWidth: "300px",
      marginTop: 0,
    },
  },
}));

export const CMTrackListContainer = styled.div((props) => ({
  "& .MuiDataGrid-root": {
    '& .MuiDataGrid-cell[data-field="releaseDate"], & .MuiDataGrid-columnHeader[data-field="releaseDate"] .MuiDataGrid-columnHeaderTitleContainer':
      {
        // justifyContent: "end !important",
        paddingRight: "10px",
      },
    '& .MuiDataGrid-cell[data-field="title"] span': {
      display: "none",
    },
  },
}));
